var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlan2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 327.242,
    height: 236.535,
    viewBox: "0 0 327.242 236.535",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3248",
    "data-name": "Group 3248",
    transform: "translate(-587.879 -4152.642)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_983",
    "data-name": "Group 983",
    transform: "translate(424.799)",
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M202.467,168.491s-1.632,38.717-8.818,37.969,4.928-43.013,4.928-43.013-30.626-24.591-44.459-26.423c0,0,12.972,41.19,6.193,38.7s-22.271-44.73-22.271-44.73-33.831-14.756-44.369,4.875S89.866,168.1,94.8,170.624s38.64,9.893,36.754,14.055-26.2,5.874-37.948-.993c0,0,5.959,37.721,24.7,40.233s27.044-7.519,38.592-5.757,19.134,6.742,12.75,8.48-25.109-4.776-36.083.887-19.508,8.742-3.3,16.185,47.266,12.358,56.417.683l1.145-1.46a7.087,7.087,0,0,1-1.145,1.46c2.714,2.562,5.4,12.39,7.106,19.85.2,1.248.572,3,1.169,5.4h0c.219,1.072.389,1.946.506,2.558,2.514,16.4-6.686,41.589-6.686,41.589l3.409,1.822c14.126-24.255,4.975-49,4.975-49-5.211-19.149-1.329-33.886-1.329-33.886s36.988-10.729,27.491-39.152C223.321,193.571,214.647,175.458,202.467,168.491Z",
    transform: "translate(74.988 4073.566)",
    fill: "#dfeafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M408.016,157.16c-1.04-21.814-37.2-23.032-37.2-23.032s-31.523,30.83-38.574,30.178,21.805-31.624,21.805-31.624c-13.013-4.215-50.485,4.621-50.485,4.621s-7.113,42.5-13.786,40.133S298,140.124,298,140.124c-13.717,1.025-29.033,13.392-29.033,13.392-20.4,21.141,7.8,46.238,7.8,46.238s-2.783,14.677-15.473,29.42h0a50.863,50.863,0,0,0-5.935,7.434l3.508.774q.741-1.318,1.551-2.514l.011-.015.024-.033c.359-.49.874-1.185,1.511-2.03l0,0,0,0c1.534-1.863,2.6-3.253,3.3-4.271l.006-.009c4.662-5.879,11.178-13.44,14.66-14.56a7,7,0,0,1-.4-1.775c.126.566.259,1.156.4,1.775,3.17,14.189,32.72,22.946,50.2,23.2s11.231-6.07,3.911-15.711-26.636-11.778-31.551-16.009,3.9-5.438,14.858-2.124,14.082,15.692,31.718,21.376S387.9,199.5,387.9,199.5c-13.288,1.121-34.078-10.653-33.991-15.131s33.016,3.224,38.446,3.072S409.057,178.975,408.016,157.16Z",
    transform: "translate(82.239 4076.624)",
    fill: "#b2cbfd",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_718",
    "data-name": "Group 718",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, -1297.85, 3091.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_716",
    "data-name": "Group 716",
    transform: "translate(2225.206 493.498)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 132.226,
    height: 178.126,
    rx: 10,
    transform: "translate(0 21.224)",
    fill: "#a4a3fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    d: "M2371.511,640.551c2.647,25.9,4.861,121.565-14.285,149.777-13.279,19.566-37.786,22.262-44.8,23.545-8.441,1.545-10.042.52-38.09,1.07-11.03.216-20.423.564-27.476.877a8.4,8.4,0,0,0,5.162,1.766h115.357a8.41,8.41,0,0,0,8.421-8.4V647.871A8.392,8.392,0,0,0,2371.511,640.551Z",
    transform: "translate(-2243.577 -618.236)",
    fill: "#8c8cf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M2313.875,714.183V874.6h109.644V714.183H2313.875Z",
    transform: "translate(-2300.419 -682.648)",
    fill: "#8080e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 105.316,
    height: 155.549,
    transform: "translate(13.455 31.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M2397.2,805.392c-8.107,17.854-15.312,33.242-31.322,45.112-16.539,12.262-35.58,15.658-52,15.534v3.694H2419.19V714.183h-2.575C2416.282,756.815,2405.218,787.732,2397.2,805.392Z",
    transform: "translate(-2300.419 -682.648)",
    fill: "#f2f7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2074",
    "data-name": "Path 2074",
    d: "M2599.157,1104.193H2546.8a2.679,2.679,0,0,0,0,5.358h52.359a2.679,2.679,0,1,0,0-5.358Z",
    transform: "translate(-2496.423 -1012.445)",
    fill: "#a2c6ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2075",
    "data-name": "Path 2075",
    d: "M2713.351,1006.805H2681.42a2.679,2.679,0,1,0,0,5.358h31.931a2.679,2.679,0,0,0,0-5.358Z",
    transform: "translate(-2610.7 -929.688)",
    fill: "#ff855a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2076",
    "data-name": "Path 2076",
    d: "M2599.157,1165.911H2546.8a2.679,2.679,0,0,0,0,5.358h52.359a2.679,2.679,0,1,0,0-5.358Z",
    transform: "translate(-2496.423 -1064.891)",
    fill: "#a2c6ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    d: "M2.679,0H55.038a2.679,2.679,0,0,1,2.679,2.679v0a2.679,2.679,0,0,1-2.679,2.679H2.679A2.679,2.679,0,0,1,0,2.679v0A2.679,2.679,0,0,1,2.679,0Z",
    transform: "translate(47.696 122.848)",
    fill: "#a2c6ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2077",
    "data-name": "Path 2077",
    d: "M2599.157,1373.971H2546.8a2.679,2.679,0,0,0,0,5.358h52.359a2.679,2.679,0,1,0,0-5.358Z",
    transform: "translate(-2496.423 -1241.693)",
    fill: "#a2c6ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2078",
    "data-name": "Path 2078",
    d: "M2599.157,1532.2H2546.8a2.679,2.679,0,0,0,0,5.358h52.359a2.679,2.679,0,1,0,0-5.358Z",
    transform: "translate(-2496.423 -1376.152)",
    fill: "#a2c6ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2079",
    "data-name": "Path 2079",
    d: "M2599.157,1598.354H2546.8a2.687,2.687,0,0,0-2.679,2.679h0a2.687,2.687,0,0,0,2.679,2.679h52.359a2.687,2.687,0,0,0,2.679-2.679h0A2.687,2.687,0,0,0,2599.157,1598.354Z",
    transform: "translate(-2496.423 -1432.648)",
    fill: "#a2c6ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2080",
    "data-name": "Path 2080",
    d: "M2645.191,540.824a4.513,4.513,0,1,0,4.35,4.51A4.432,4.432,0,0,0,2645.191,540.824Zm0,8.063a3.556,3.556,0,1,1,3.427-3.553A3.492,3.492,0,0,1,2645.191,548.887Z",
    transform: "translate(-2578.322 -533.642)",
    fill: "#f7d02d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2081",
    "data-name": "Path 2081",
    d: "M2487.182,511.87a7.994,7.994,0,0,1-1.919-3.411c-.513-1.637-.224-2.21-.548-4.264a14.459,14.459,0,0,0-1.371-4.548,11.788,11.788,0,0,0-4.661-4.69l-.062-.037a10.531,10.531,0,0,0-10.567,0l-.063.037a11.788,11.788,0,0,0-4.661,4.69,14.457,14.457,0,0,0-1.371,4.548c-.325,2.053-.036,2.627-.548,4.264a7.993,7.993,0,0,1-1.919,3.411,7.173,7.173,0,0,1-3.975,1.99h-17.272v9.523a9.777,9.777,0,0,0,9.6,9.949h50.995a9.777,9.777,0,0,0,9.6-9.949v-9.523h-17.273A7.175,7.175,0,0,1,2487.182,511.87Zm-13.845-2.171a4.513,4.513,0,1,1,4.35-4.51A4.432,4.432,0,0,1,2473.337,509.7Z",
    transform: "translate(-2406.475 -493.498)",
    fill: "#ffda3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2082",
    "data-name": "Path 2082",
    d: "M2664,511.873a7.988,7.988,0,0,1-1.919-3.411c-.513-1.637-.224-2.21-.549-4.264a14.452,14.452,0,0,0-1.371-4.548,11.788,11.788,0,0,0-4.661-4.69l-.063-.037a10.529,10.529,0,0,0-8.744-.835,10.1,10.1,0,0,1,5.611,1.274c4.162,2.425,5.722,7.641,5.771,8.657.733,15.149,10.3,12.926,12.624,13.707,11.482,3.847,4.952,15.61-8.5,15.61h13.454a9.777,9.777,0,0,0,9.6-9.949v-9.523H2667.98A7.174,7.174,0,0,1,2664,511.873Z",
    transform: "translate(-2583.474 -493.502)",
    fill: "#f7d02d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2083",
    "data-name": "Path 2083",
    d: "M2457.369,642.339a1.4,1.4,0,0,0-1.368,1.4c0,2.224-.008,6.468,0,7.292.04,3.246,1.866.047,4.431-2.345,5.189-4.838,10.959-3.227,10.958-6.113C2471.393,642.045,2461.135,642.247,2457.369,642.339Z",
    transform: "translate(-2421.299 -619.655)",
    fill: "#ffee52"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_709",
    "data-name": "Group 709",
    transform: "translate(56.72 2.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2084",
    "data-name": "Path 2084",
    d: "M2608.9,511.585a1.081,1.081,0,0,0-1.492-.62,9.091,9.091,0,0,0-2.689,1.987,10.229,10.229,0,0,0-2.46,7.671,1.08,1.08,0,1,0,2.156-.149,8.043,8.043,0,0,1,1.89-6.049,6.94,6.94,0,0,1,2.063-1.52,1.073,1.073,0,0,0,.533-1.317Z",
    transform: "translate(-2602.236 -510.857)",
    fill: "#ffee52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2085",
    "data-name": "Path 2085",
    d: "M2225.206,641.852V778.907c3.111-72.113,4.8-119.972,4.105-128.12-.137-1.6-.9-7.93,2.885-11.9,1.744-1.83,3.726-2.4,7.575-3.607,1.63-.513,3.629-1.152,5.95-1.917H2233.7A8.492,8.492,0,0,0,2225.206,641.852Z",
    transform: "translate(-2225.206 -612.136)",
    fill: "#b6b6fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_710",
    "data-name": "Group 710",
    transform: "translate(23.743 90.363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2086",
    "data-name": "Path 2086",
    d: "M2383.17,1113.885h18.477v-18.477H2383.17Zm2.479-16h13.519v13.519h-13.519Z",
    transform: "translate(-2383.17 -1095.408)",
    fill: "#a2c6ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_711",
    "data-name": "Group 711",
    transform: "translate(23.743 121.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2087",
    "data-name": "Path 2087",
    d: "M2383.17,1323.5h18.477v-18.477H2383.17Zm2.479-16h13.519v13.519h-13.519Z",
    transform: "translate(-2383.17 -1305.022)",
    fill: "#a2c6ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_712",
    "data-name": "Group 712",
    transform: "translate(23.081 84.642)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2088",
    "data-name": "Path 2088",
    d: "M2397.625,1057.644a1.669,1.669,0,0,0-2.215.813l-7.909,17.094-5.817-6.371a1.668,1.668,0,0,0-2.356-.107h0a1.668,1.668,0,0,0-.107,2.357l9.2,10.077,10.016-21.649A1.668,1.668,0,0,0,2397.625,1057.644Z",
    transform: "translate(-2378.784 -1057.49)",
    fill: "#ff855a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_713",
    "data-name": "Group 713",
    transform: "translate(23.081 116.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2089",
    "data-name": "Path 2089",
    d: "M2397.625,1267.259a1.669,1.669,0,0,0-2.215.813l-7.909,17.094-5.817-6.371a1.668,1.668,0,0,0-2.464,2.25l9.2,10.077,10.016-21.649A1.667,1.667,0,0,0,2397.625,1267.259Z",
    transform: "translate(-2378.784 -1267.104)",
    fill: "#ff855a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_714",
    "data-name": "Group 714",
    transform: "translate(23.743 154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2090",
    "data-name": "Path 2090",
    d: "M2383.17,1539.688h18.477v-18.477H2383.17Zm2.479-16h13.519v13.519h-13.519Z",
    transform: "translate(-2383.17 -1521.211)",
    fill: "#a2c6ea"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_715",
    "data-name": "Group 715",
    transform: "translate(23.081 148.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2091",
    "data-name": "Path 2091",
    d: "M2397.625,1483.448a1.668,1.668,0,0,0-2.215.813l-7.909,17.094-5.817-6.371a1.668,1.668,0,0,0-2.464,2.25l9.2,10.077,10.016-21.648A1.668,1.668,0,0,0,2397.625,1483.448Z",
    transform: "translate(-2378.784 -1483.293)",
    fill: "#ff855a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_717",
    "data-name": "Group 717",
    transform: "translate(2251.918 548.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2092",
    "data-name": "Path 2092",
    d: "M2411.024,863.145a7.041,7.041,0,0,0-1.94-.236h-2.819a1.482,1.482,0,0,0-1.157.416,1.846,1.846,0,0,0-.363,1.265v8.778a4.2,4.2,0,0,0,.1.99,1.114,1.114,0,0,0,.47.678,1.77,1.77,0,0,0,1,.233h2.818a7.7,7.7,0,0,0,1.357-.109,4.123,4.123,0,0,0,1.15-.386,3.915,3.915,0,0,0,.99-.732,5.16,5.16,0,0,0,.931-1.328,6.5,6.5,0,0,0,.533-1.654,10.9,10.9,0,0,0,.171-2,6.668,6.668,0,0,0-1.726-5.006A3.578,3.578,0,0,0,2411.024,863.145Zm-.373,9.3a1.5,1.5,0,0,1-.5.325,2.217,2.217,0,0,1-.582.151c-.2.021-.473.032-.824.032H2407.3v-7.734h1.232a5.049,5.049,0,0,1,1.626.23,2.03,2.03,0,0,1,1.068,1.031,5.607,5.607,0,0,1,.453,2.561A4.6,4.6,0,0,1,2410.651,872.445Z",
    transform: "translate(-2404.745 -862.705)",
    fill: "#7753bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2093",
    "data-name": "Path 2093",
    d: "M2479.24,861.564a1.14,1.14,0,0,0-.923.439,1.912,1.912,0,0,0-.342,1.225v9.431a1.917,1.917,0,0,0,.345,1.229,1.14,1.14,0,0,0,.92.443,1.165,1.165,0,0,0,.941-.439,1.911,1.911,0,0,0,.347-1.234v-9.431a1.894,1.894,0,0,0-.347-1.231A1.17,1.17,0,0,0,2479.24,861.564Z",
    transform: "translate(-2466.863 -861.564)",
    fill: "#7753bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2094",
    "data-name": "Path 2094",
    d: "M2515.556,872.952h-4.844v-3.015H2515a1.159,1.159,0,0,0,.885-.319,1.128,1.128,0,0,0,.293-.8,1.091,1.091,0,0,0-.3-.794,1.181,1.181,0,0,0-.878-.308h-4.291v-2.549h4.677a1.22,1.22,0,0,0,.908-.316,1.126,1.126,0,0,0,.307-.818,1.114,1.114,0,0,0-.307-.81,1.218,1.218,0,0,0-.908-.316h-5.709a1.847,1.847,0,0,0-.843.173,1.109,1.109,0,0,0-.524.58,2.422,2.422,0,0,0-.154.929v9a1.857,1.857,0,0,0,.358,1.264,1.478,1.478,0,0,0,1.162.417h5.877a1.216,1.216,0,0,0,.908-.324,1.14,1.14,0,0,0,.314-.826,1.161,1.161,0,0,0-.314-.842A1.216,1.216,0,0,0,2515.556,872.952Z",
    transform: "translate(-2492.466 -862.705)",
    fill: "#7753bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2095",
    "data-name": "Path 2095",
    d: "M2575.057,862.909h-6.874a1.316,1.316,0,0,0-.947.324,1.163,1.163,0,0,0-.341.875,1.178,1.178,0,0,0,.325.859,1.3,1.3,0,0,0,.962.332h2.165v8.5a1.913,1.913,0,0,0,.346,1.234,1.158,1.158,0,0,0,.933.439,1.144,1.144,0,0,0,.923-.434,1.925,1.925,0,0,0,.343-1.238v-8.5h2.164a1.327,1.327,0,0,0,.968-.33,1.163,1.163,0,0,0,.334-.861,1.184,1.184,0,0,0-.329-.863A1.311,1.311,0,0,0,2575.057,862.909Z",
    transform: "translate(-2542.29 -862.705)",
    fill: "#7753bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2096",
    "data-name": "Path 2096",
    d: "M2667.207,863.856a2.943,2.943,0,0,0-1.21-.725,6.738,6.738,0,0,0-1.953-.222h-2.775a1.572,1.572,0,0,0-1.182.4,1.787,1.787,0,0,0-.382,1.278v9.227a1.9,1.9,0,0,0,.342,1.212,1.194,1.194,0,0,0,1.861,0,1.9,1.9,0,0,0,.35-1.225v-3.194h1.786a4.431,4.431,0,0,0,3.126-1,3.823,3.823,0,0,0,1.066-2.914,4.736,4.736,0,0,0-.259-1.609A3.292,3.292,0,0,0,2667.207,863.856Zm-1.789,3.852a1.293,1.293,0,0,1-.685.511,3.736,3.736,0,0,1-1.214.169h-1.261V865.12h1.261a2.414,2.414,0,0,1,1.766.461,1.769,1.769,0,0,1,.37,1.165A1.732,1.732,0,0,1,2665.417,867.708Z",
    transform: "translate(-2621.016 -862.705)",
    fill: "#7753bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2097",
    "data-name": "Path 2097",
    d: "M2731.71,871.746h-4.188v-8.518a1.894,1.894,0,0,0-.348-1.231,1.169,1.169,0,0,0-.94-.434,1.137,1.137,0,0,0-.927.44,1.928,1.928,0,0,0-.338,1.224v9.219a1.858,1.858,0,0,0,.358,1.264,1.48,1.48,0,0,0,1.162.417h5.221a1.293,1.293,0,0,0,.946-.33,1.152,1.152,0,0,0,.335-.853,1.178,1.178,0,0,0-.336-.855A1.268,1.268,0,0,0,2731.71,871.746Z",
    transform: "translate(-2676.376 -861.564)",
    fill: "#7753bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2098",
    "data-name": "Path 2098",
    d: "M2785.449,863.958c-.13-.382-.24-.7-.326-.931a3.839,3.839,0,0,0-.33-.684,1.73,1.73,0,0,0-.549-.556,1.579,1.579,0,0,0-.858-.222,1.563,1.563,0,0,0-.851.222,1.7,1.7,0,0,0-.551.567,4.513,4.513,0,0,0-.366.816l-.28.8-2.73,7.772c-.113.314-.2.563-.245.74a2.087,2.087,0,0,0-.08.559,1.276,1.276,0,0,0,.366.893,1.153,1.153,0,0,0,.863.4.958.958,0,0,0,.854-.4,5.777,5.777,0,0,0,.533-1.26l.466-1.4h4.06l.465,1.37v0c.068.185.15.4.245.645a2.8,2.8,0,0,0,.288.58,1.121,1.121,0,0,0,.37.335,1.076,1.076,0,0,0,.532.127,1.157,1.157,0,0,0,.892-.412,1.317,1.317,0,0,0,.359-.893,4.356,4.356,0,0,0-.34-1.348Zm-3.391,5.1,1.315-4.111,1.339,4.111Z",
    transform: "translate(-2721.599 -861.564)",
    fill: "#7753bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M2862.326,861.564a1.045,1.045,0,0,0-.872.423,1.862,1.862,0,0,0-.306,1.16v6.406l-3.794-6.438q-.175-.31-.339-.6a3.171,3.171,0,0,0-.342-.5,1.409,1.409,0,0,0-.423-.331,1.278,1.278,0,0,0-.587-.128,1.35,1.35,0,0,0-.806.27,1.483,1.483,0,0,0-.528.694,3.04,3.04,0,0,0-.128.987v9.235a1.845,1.845,0,0,0,.318,1.153,1.13,1.13,0,0,0,1.769.007,1.81,1.81,0,0,0,.328-1.159v-6.291l3.695,6.352c.117.192.235.381.352.563a3.015,3.015,0,0,0,.4.51,1.513,1.513,0,0,0,.5.341,1.589,1.589,0,0,0,.6.108c.62,0,1.36-.307,1.36-1.771v-9.415a1.872,1.872,0,0,0-.31-1.161A1.071,1.071,0,0,0,2862.326,861.564Z",
    transform: "translate(-2785.997 -861.564)",
    fill: "#7753bc"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_708",
    "data-name": "Group 708",
    transform: "translate(523.494 4097.466)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_688",
    "data-name": "Group 688",
    transform: "translate(158.832 238.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2012",
    "data-name": "Path 2012",
    d: "M300.545,286.341s-4.39,10.012-22.257,14.252c-17.24,4.083-40.848.324-42.479.057-1.63.27-25.23,4.077-42.479.028-17.875-4.2-22.285-14.206-22.285-14.206l8.622-20.423L210.02,268.4l2.953-3.48,22.806,6.023,22.793-6.07,2.959,3.474,30.536-2.433Z",
    transform: "translate(-167.757 -264.873)",
    fill: "#052c39"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2013",
    "data-name": "Path 2013",
    d: "M255.36,313.733a64.341,64.341,0,0,0,8.783-1.72",
    transform: "translate(-183.748 -273.813)",
    fill: "none",
    stroke: "#ae3838",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_675",
    "data-name": "Group 675",
    transform: "translate(3.925 29.161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2014",
    "data-name": "Path 2014",
    d: "M197.643,318.352c6.485-.993,10.714-1.49,16.07-2.271s13.25-1.777,12.891-8.472-10.086-6.546-12.341-6.333-14.311.72-20.02-.049c-1.4-.189-2.446-.3-3.352-.349h0c-2.8-.133-4.287.437-10.672,1.773-8.456,1.771-8.381,5.859-8.381,5.859s-.2,2.678,3.131,4.818l0,0a12.176,12.176,0,0,0,2.017,1.023C182.415,316.534,191.16,319.345,197.643,318.352Z",
    transform: "translate(-171.832 -300.859)",
    fill: "#f2f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2015",
    "data-name": "Path 2015",
    d: "M232.307,307.987s.989,2.325-4.648,4.3-10.394,3.641-13.286,2.234-4.026-6.353-2.512-9.444,7.023-2.3,9.609-1.6,7.849.791,9.636,2.2S232.307,307.987,232.307,307.987Z",
    transform: "translate(-179.296 -301.235)",
    fill: "#ffa78f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2016",
    "data-name": "Path 2016",
    d: "M174.966,313.328c-3.213-2.854-2.725-6.169.884-7.994,3.57-1.8,14.784-4.4,15.038-4.456-2.8-.133-4.287.437-10.672,1.773-8.456,1.771-8.381,5.859-8.381,5.859S171.631,311.188,174.966,313.328Z",
    transform: "translate(-171.832 -300.859)",
    fill: "#b2c9d8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_668",
    "data-name": "Group 668",
    transform: "translate(27.625 4.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_667",
    "data-name": "Group 667"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2017",
    "data-name": "Path 2017",
    d: "M207.2,312.815a.443.443,0,0,1-.373-.2,5.6,5.6,0,0,1-.153-5.768.446.446,0,0,1,.758.471,4.7,4.7,0,0,0,.14,4.807.446.446,0,0,1-.373.69Z",
    transform: "translate(-205.922 -306.637)",
    fill: "#212473"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_670",
    "data-name": "Group 670",
    transform: "translate(25.744 4.9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_669",
    "data-name": "Group 669"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2018",
    "data-name": "Path 2018",
    d: "M204.883,313.085a.443.443,0,0,1-.372-.2,5.6,5.6,0,0,1-.154-5.768.446.446,0,0,1,.758.471,4.7,4.7,0,0,0,.14,4.807.446.446,0,0,1-.373.69Z",
    transform: "translate(-203.602 -306.906)",
    fill: "#212473"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_672",
    "data-name": "Group 672",
    transform: "translate(23.864 4.903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_671",
    "data-name": "Group 671"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2019",
    "data-name": "Path 2019",
    d: "M202.563,313.087a.444.444,0,0,1-.373-.2,5.6,5.6,0,0,1-.153-5.768.446.446,0,0,1,.758.471,4.7,4.7,0,0,0,.14,4.807.446.446,0,0,1-.373.69Z",
    transform: "translate(-201.281 -306.909)",
    fill: "#212473"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_674",
    "data-name": "Group 674",
    transform: "translate(21.983 5.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2020",
    "data-name": "Path 2020",
    d: "M200.243,313.267a.448.448,0,0,1-.374-.2,5.6,5.6,0,0,1-.153-5.768.446.446,0,0,1,.758.471,4.756,4.756,0,0,0,.139,4.805.446.446,0,0,1-.371.692Z",
    transform: "translate(-198.96 -307.089)",
    fill: "#212473"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_676",
    "data-name": "Group 676",
    transform: "translate(39.979 1.01)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2021",
    "data-name": "Path 2021",
    d: "M229.546,313.381c-3.4.222-6.16.342-7.8.395l-1.622.052s-3.221-2.291-3.8-10.645c0,0,2.252-.784,5.78-2.006.765-.262,1.579-.54,2.453-.843l3.3.4a87.288,87.288,0,0,1,3.236,8.133C231.349,309.933,230.435,311.859,229.546,313.381Z",
    transform: "translate(-216.324 -272.608)",
    fill: "#ffa78f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2022",
    "data-name": "Path 2022",
    d: "M230.816,313.381l-7.8.395.357-12.6c.765-.262,1.579-.54,2.453-.843l3.3.4a87.291,87.291,0,0,1,3.236,8.133C232.619,309.933,231.7,311.859,230.816,313.381Z",
    transform: "translate(-217.593 -272.608)",
    fill: "#f9867d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2023",
    "data-name": "Path 2023",
    d: "M298.888,294.392c-5.242,2.519-14.333,4.813-24.315,6.774-21.5,4.224-47.117,6.906-47.117,6.906l-3.193-15.931,26.045-8.9L297.263,267.2s11.005-4.919,14.722,6.263S308.985,289.549,298.888,294.392Z",
    transform: "translate(-217.83 -266.119)",
    fill: "#043649"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_687",
    "data-name": "Group 687",
    transform: "translate(0 1.071)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_685",
    "data-name": "Group 685",
    transform: "translate(76.51 27.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2024",
    "data-name": "Path 2024",
    d: "M290.4,318.182c-6.488-.98-10.718-1.469-16.075-2.239s-13.253-1.75-12.908-8.446,10.073-6.566,12.328-6.357,14.312.691,20.02-.09c1.4-.192,2.444-.31,3.351-.356h0c2.8-.139,4.288.428,10.675,1.751,8.459,1.753,8.394,5.842,8.394,5.842s.208,2.678-3.121,4.825l0,0a12.061,12.061,0,0,1-2.015,1.027C305.622,316.333,296.883,319.162,290.4,318.182Z",
    transform: "translate(-261.404 -300.674)",
    fill: "#f2f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    d: "M263.57,307.881s-.985,2.327,4.656,4.295,10.4,3.62,13.291,2.207,4.013-6.36,2.493-9.448-7.028-2.284-9.612-1.576-7.847.806-9.631,2.218S263.57,307.881,263.57,307.881Z",
    transform: "translate(-261.798 -301.06)",
    fill: "#ffa78f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    d: "M321.424,313.112c3.207-2.861,2.712-6.176-.9-7.992-3.574-1.8-14.793-4.366-15.047-4.425,2.8-.139,4.288.428,10.675,1.751,8.459,1.753,8.394,5.842,8.394,5.842S324.753,310.965,321.424,313.112Z",
    transform: "translate(-269.763 -300.674)",
    fill: "#b2c9d8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_678",
    "data-name": "Group 678",
    transform: "translate(25.439 4.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_677",
    "data-name": "Group 677"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2027",
    "data-name": "Path 2027",
    d: "M293.243,312.656a.445.445,0,0,0,.373-.2,5.6,5.6,0,0,0,.141-5.768.446.446,0,0,0-.758.472,4.7,4.7,0,0,1-.13,4.807.445.445,0,0,0,.374.69Z",
    transform: "translate(-292.797 -306.477)",
    fill: "#212473"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_680",
    "data-name": "Group 680",
    transform: "translate(27.319 4.917)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_679",
    "data-name": "Group 679"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2028",
    "data-name": "Path 2028",
    d: "M295.564,312.921a.442.442,0,0,0,.372-.2,5.6,5.6,0,0,0,.142-5.768.446.446,0,1,0-.757.472,4.7,4.7,0,0,1-.13,4.807.446.446,0,0,0,.13.617A.437.437,0,0,0,295.564,312.921Z",
    transform: "translate(-295.117 -306.742)",
    fill: "#212473"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_682",
    "data-name": "Group 682",
    transform: "translate(29.2 4.916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_681",
    "data-name": "Group 681"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2029",
    "data-name": "Path 2029",
    d: "M297.885,312.919a.443.443,0,0,0,.372-.2,5.6,5.6,0,0,0,.142-5.768.446.446,0,0,0-.758.472,4.7,4.7,0,0,1-.13,4.807.446.446,0,0,0,.374.69Z",
    transform: "translate(-297.438 -306.74)",
    fill: "#212473"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_684",
    "data-name": "Group 684",
    transform: "translate(31.08 5.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_683",
    "data-name": "Group 683"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2030",
    "data-name": "Path 2030",
    d: "M300.2,313.094a.446.446,0,0,0,.374-.2,5.6,5.6,0,0,0,.141-5.768.446.446,0,1,0-.758.472,4.757,4.757,0,0,1-.13,4.806.446.446,0,0,0,.373.69Z",
    transform: "translate(-299.759 -306.915)",
    fill: "#212473"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_686",
    "data-name": "Group 686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2031",
    "data-name": "Path 2031",
    d: "M267.84,313.27c3.4.216,6.16.331,7.8.379,1.042.032,1.622.049,1.622.049s3.216-2.3,3.779-10.652c0,0-2.254-.78-5.784-2-.765-.259-1.581-.536-2.455-.838l-3.3.408a87.115,87.115,0,0,0-3.219,8.138C266.03,309.826,266.948,311.75,267.84,313.27Z",
    transform: "translate(-185.811 -272.646)",
    fill: "#ffa78f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2032",
    "data-name": "Path 2032",
    d: "M267.84,313.27l7.8.379-.382-12.6c-.765-.259-1.581-.536-2.455-.838l-3.3.408a87.115,87.115,0,0,0-3.219,8.138C266.03,309.826,266.948,311.75,267.84,313.27Z",
    transform: "translate(-185.811 -272.646)",
    fill: "#f9867d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2033",
    "data-name": "Path 2033",
    d: "M252.618,307.995l3.156-15.944-73.048-24.789s-11.016-4.9-14.712,6.288,3.036,16.088,13.138,20.909C197.71,302.361,252.618,307.995,252.618,307.995Z",
    transform: "translate(-166.988 -266.194)",
    fill: "#063c50"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_692",
    "data-name": "Group 692",
    transform: "translate(247.52 177.957)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_690",
    "data-name": "Group 690",
    transform: "translate(18.703 30.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2034",
    "data-name": "Path 2034",
    d: "M342.313,243.644l-2.5,9.155a132,132,0,0,1-19.956,4.668c-.124.017-.255.038-.386.06a108.294,108.294,0,0,1-19.959,1.112l3.043-13.967c3.891-.4,9.221-.438,14.837-.4C326.65,244.317,336.68,244.555,342.313,243.644Z",
    transform: "translate(-299.513 -230.74)",
    fill: "#ffa78f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2035",
    "data-name": "Path 2035",
    d: "M317.393,244.415l2.465,13.2c-.124.017-.255.038-.386.06a108.294,108.294,0,0,1-19.959,1.112l3.043-13.967C306.447,244.419,311.777,244.378,317.393,244.415Z",
    transform: "translate(-299.513 -230.885)",
    fill: "#f9867d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_689",
    "data-name": "Group 689",
    transform: "translate(38.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2036",
    "data-name": "Path 2036",
    d: "M346.785,250.433a14.17,14.17,0,0,1,3.883-.245c1.531.232,7.121-.311,11.7-3.5s7.759-3.784,9.11-5.023-1.5-1.882-5.1.022c-2.706,1.432-2.92,1.13-2.92,1.13a65.5,65.5,0,0,1,7.1-4.475c2.733-1.331,3.438-1.6,3.7-2.215s-1.7-1.92-4.3-.369-5.488,2.863-6.59,3.528c0,0,2.82-1.949,3.591-2.634s4.877-4.273,5.515-4.826.929-1.041.576-1.54c-.286-.406-1.259-.657-3.433,1.13a91.217,91.217,0,0,1-8.065,5.418s2.7-2.361,2.343-4.772-6.513-4.428-7.13-4.339-.527,1.414.564,2.265,3.182,1.875,3.273,2.905-2.258,3.448-3.258,3.745-.291-5.227-.456-6.266-1.565-2.556-2.388-2.319-.259,2.561-.314,4.032a11.018,11.018,0,0,1-2.312,5.449,12.781,12.781,0,0,0-2.52,4.3c-.438,1.443-2.351,1.595-2.351,1.595Z",
    transform: "translate(-346.785 -227.72)",
    fill: "#ffa78f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2037",
    "data-name": "Path 2037",
    d: "M359.069,241.518s-1.412,3.247-3.778,4.583",
    transform: "translate(-348.398 -230.337)",
    fill: "none",
    stroke: "#ae3838",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2038",
    "data-name": "Path 2038",
    d: "M361.046,241s.848,4.1,2.207,5.745",
    transform: "translate(-349.49 -230.24)",
    fill: "none",
    stroke: "#ae3838",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_691",
    "data-name": "Group 691"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2039",
    "data-name": "Path 2039",
    d: "M308.445,233.514l.522,15.43s-13.829,1.015-17.973-.4c-1.808-.618-4.186-5.932-5.9-10.291s-3.776-10.7-3.776-10.7l-4.879-37.47a17.427,17.427,0,0,1,9.771,5.151c3.848,3.987,10.684,34.334,13.469,37.178C301.333,234.1,303.126,232.779,308.445,233.514Z",
    transform: "translate(-276.433 -190.077)",
    fill: "#f2f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2040",
    "data-name": "Path 2040",
    d: "M312.048,242.932a6.76,6.76,0,0,1,5.839-.075l1.489,15.458s-3.851,1.788-5.781.861Z",
    transform: "translate(-283.188 -199.964)",
    fill: "#c7d7e2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_696",
    "data-name": "Group 696",
    transform: "translate(123.981 177.962)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_694",
    "data-name": "Group 694",
    transform: "translate(0 30.676)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2041",
    "data-name": "Path 2041",
    d: "M152.386,243.847,154.9,253a131.939,131.939,0,0,0,19.965,4.628c.124.017.254.038.386.059a108.393,108.393,0,0,0,19.962,1.071l-3.072-13.961c-3.891-.389-9.221-.419-14.838-.371C168.051,244.488,158.02,244.746,152.386,243.847Z",
    transform: "translate(-129.368 -230.956)",
    fill: "#ffa78f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2042",
    "data-name": "Path 2042",
    d: "M182.569,244.554l-2.438,13.2c.124.017.254.038.386.059a108.39,108.39,0,0,0,19.962,1.071l-3.072-13.961C193.515,244.536,188.186,244.506,182.569,244.554Z",
    transform: "translate(-134.63 -231.086)",
    fill: "#f9867d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_693",
    "data-name": "Group 693"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2043",
    "data-name": "Path 2043",
    d: "M151.512,250.63a14.162,14.162,0,0,0-3.883-.237c-1.531.235-7.121-.3-11.71-3.476s-7.766-3.769-9.12-5,1.5-1.885,5.1.011c2.708,1.426,2.921,1.124,2.921,1.124a65.467,65.467,0,0,0-7.1-4.46c-2.737-1.325-3.442-1.59-3.707-2.208s1.7-1.923,4.3-.377,5.493,2.852,6.6,3.514c0,0-2.824-1.942-3.6-2.627s-4.886-4.262-5.525-4.814-.931-1.04-.579-1.54c.285-.407,1.258-.66,3.436,1.123a91.112,91.112,0,0,0,8.075,5.4s-2.706-2.354-2.352-4.767,6.5-4.441,7.122-4.352.529,1.412-.56,2.265-3.178,1.882-3.267,2.912,2.264,3.443,3.265,3.738.28-5.228.443-6.268,1.56-2.559,2.384-2.323.264,2.56.323,4.031a11.013,11.013,0,0,0,2.322,5.444,12.788,12.788,0,0,1,2.529,4.3c.442,1.442,2.354,1.59,2.354,1.59Z",
    transform: "translate(-123.981 -227.939)",
    fill: "#ffa78f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2044",
    "data-name": "Path 2044",
    d: "M144.759,241.737s1.418,3.244,3.787,4.576",
    transform: "translate(-127.922 -230.555)",
    fill: "none",
    stroke: "#ae3838",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2045",
    "data-name": "Path 2045",
    d: "M143.151,241.224s-.84,4.1-2.2,5.749",
    transform: "translate(-127.201 -230.458)",
    fill: "none",
    stroke: "#ae3838",
    strokeLinecap: "round",
    strokeWidth: 0.75
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_695",
    "data-name": "Group 695",
    transform: "translate(48.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M188.664,233.621l-.491,15.431s13.832.987,17.973-.438c1.806-.622,4.174-5.941,5.884-10.3s3.754-10.711,3.754-10.711l4.8-37.479s-4.8-.681-9.223,3.925c-3.839,3.994-11.153,35.6-13.931,38.451C195.778,234.193,193.982,232.874,188.664,233.621Z",
    transform: "translate(-184.517 -190.083)",
    fill: "#f2f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M190.959,243.054a6.763,6.763,0,0,0-5.84-.063l-1.458,15.461s3.855,1.781,5.783.849Z",
    transform: "translate(-183.661 -199.993)",
    fill: "#c7d7e2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_702",
    "data-name": "Group 702",
    transform: "translate(204.324 126.17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_697",
    "data-name": "Group 697",
    transform: "translate(11.685 40.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2048",
    "data-name": "Path 2048",
    d: "M258.894,189.79l-10.659,10.465-10.688-10.443a19.176,19.176,0,0,0,2.615-5.856,29.152,29.152,0,0,0,.952-8.4l14.184-.014a27.9,27.9,0,0,0,.326,5.264A21.367,21.367,0,0,0,258.894,189.79Z",
    transform: "translate(-237.546 -175.542)",
    fill: "#ffa78f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2049",
    "data-name": "Path 2049",
    d: "M256.235,180.806a32.4,32.4,0,0,1-15.462,3.15,29.153,29.153,0,0,0,.952-8.4l14.184-.014A27.9,27.9,0,0,0,256.235,180.806Z",
    transform: "translate(-238.158 -175.542)",
    fill: "#f9867d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_698",
    "data-name": "Group 698",
    transform: "translate(0 24.867)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2050",
    "data-name": "Path 2050",
    d: "M275.472,158.676c.966,1.928-.431,4.583-3.121,5.932s-5.654.879-6.62-1.049.43-4.583,3.12-5.931S274.5,156.749,275.472,158.676Z",
    transform: "translate(-231.149 -156.858)",
    fill: "#f9867d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2051",
    "data-name": "Path 2051",
    d: "M223.413,159.08c-.937,1.942.5,4.576,3.211,5.883s5.667.792,6.6-1.15-.5-4.576-3.211-5.883S224.35,157.137,223.413,159.08Z",
    transform: "translate(-223.127 -156.924)",
    fill: "#f9867d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_699",
    "data-name": "Group 699",
    transform: "translate(6.258 6.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2052",
    "data-name": "Path 2052",
    d: "M263.678,152.98c.079,10.355-7.349,19.838-16.414,19.908s-16.334-9.3-16.414-19.656,7.2-18.8,16.27-18.874S263.6,142.625,263.678,152.98Z",
    transform: "translate(-230.849 -134.357)",
    fill: "#ffa78f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2053",
    "data-name": "Path 2053",
    d: "M232.66,152.026a33.1,33.1,0,0,1,1.549-3.718l3.846-.557s-.027,1.566,2.438,1.649,13.6-1.006,18.61-2.455c0,0,2.406,2.311,2.712,4.09,0,0,2.052-3.62-.007-6.037s-6.821-7.284-8.239-7.283l-14.681.015s-4.86,6.011-5.313,6.125-.923,1.387-.923,1.387l-1.6,5.826Z",
    transform: "translate(-230.887 -134.994)",
    fill: "#f9867d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2054",
    "data-name": "Path 2054",
    d: "M231.615,160.515s-.673-8.429,2.38-15.508l-.648-9.295S222.872,141.127,231.615,160.515Z",
    transform: "translate(-224.076 -127.98)",
    fill: "#072d38"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_700",
    "data-name": "Group 700",
    transform: "translate(0.917)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    d: "M261.215,158.675s.656-8.431-2.411-15.5a103.417,103.417,0,0,1-16.017,2.537c-7.832.487-2.28-2.208-1.616-2.536a28.158,28.158,0,0,1-9.823,1.59h-.009a1.059,1.059,0,0,1-.16-.008,11.713,11.713,0,0,1-1.992-.309,5.56,5.56,0,0,1-.866-.293h-.008a7.146,7.146,0,0,1-1.758-1.116,8.267,8.267,0,0,1-2.3-3.233,50.178,50.178,0,0,0,3.568-4.416l.05-.075c.268-.37.453-.647.553-.8a1.326,1.326,0,0,0,.084-.118,21.9,21.9,0,0,1,7.407-6.327c7.165-3.831,20.277-1.836,23.513,5.809C259.434,133.875,269.919,139.269,261.215,158.675Z",
    transform: "translate(-224.258 -126.17)",
    fill: "#072d38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2056",
    "data-name": "Path 2056",
    d: "M259.434,133.875s-6.856-6.154-14.151-6.045a20.793,20.793,0,0,0-15.532,7.723,44.286,44.286,0,0,1-4.1,4.862,9.168,9.168,0,0,0,.91,2.621,8.267,8.267,0,0,1-2.3-3.233,50.178,50.178,0,0,0,3.568-4.416l.05-.075c.268-.37.453-.647.553-.8a1.326,1.326,0,0,0,.084-.118,21.9,21.9,0,0,1,7.407-6.327C243.086,124.235,256.2,126.23,259.434,133.875Z",
    transform: "translate(-224.258 -126.17)",
    fill: "#0f5c60"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707",
    transform: "translate(194.247 176.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    d: "M270.961,253.247c1.111,1.638-6.432,6.074-26.895,8.356h-.016c-.269-.034-.538-.058-.807-.092-.286-.033-.563-.066-.84-.091-19.223-2.3-26.338-6.521-25.272-8.119a7.678,7.678,0,0,0,1.065-3.027c0-.109-.009-.21-.009-.319-.069-1.942-.215-4.134-.41-6.5-.9-11.236-2.834-26.295-2.651-35.952.255-13.531,1.606-16.247,7.975-17.649a79.156,79.156,0,0,1,12.009-1.139s2.226,6.982,8.849,6.975,8.834-6.992,8.834-6.992c1.017.041,2.051.082,3.093.139a62.871,62.871,0,0,1,8.918.974c6.372,1.389,7.727,4.1,8.01,17.633.036,1.95-1.425,19.365-2.321,31.821-.323,4.5-.571,8.363-.653,10.607A8.091,8.091,0,0,0,270.961,253.247Z",
    transform: "translate(-211.531 -188.703)",
    fill: "#f2f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_703",
    "data-name": "Group 703",
    transform: "translate(0 16.546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    d: "M217.091,241.03q-1.578-15.917-2.217-31.909",
    transform: "translate(-211.485 -209.121)",
    fill: "none",
    stroke: "#c7d7e2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M210.692,222.445a39.842,39.842,0,0,0,4.111,5.476",
    transform: "translate(-210.692 -211.648)",
    fill: "none",
    stroke: "#c7d7e2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_704",
    "data-name": "Group 704",
    transform: "translate(59.509 27.225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2060",
    "data-name": "Path 2060",
    d: "M284.129,227.177A21.247,21.247,0,0,0,288.3,222.3",
    transform: "translate(-284.129 -222.3)",
    fill: "none",
    stroke: "#c7d7e2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2061",
    "data-name": "Path 2061",
    d: "M244.515,273.438H244.5c-20.467-2.241-28.019-6.662-26.92-8.3a7.678,7.678,0,0,0,1.065-3.027c0-.109-.009-.21-.009-.319,3.045,2.728,10.008,6.394,25.05,5.2,23.22-1.839,27.256-15.887,27.256-15.887-.323,4.5-.571,8.363-.653,10.607a8.09,8.09,0,0,0,1.122,3.369C272.52,266.72,264.978,271.156,244.515,273.438Z",
    transform: "translate(-211.978 -200.538)",
    fill: "#d3e3ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M248.03,201.248s-1.333,12.721,3.659,18.609,9.3,11.141,9.2,24.382l7.058,3.532s-.733-17.854-8.219-24.5-8.454-11.63-8.937-13.216a69.347,69.347,0,0,1-.939-7.818Z",
    transform: "translate(-217.743 -191.082)",
    fill: "#c1d7e5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_706",
    "data-name": "Group 706",
    transform: "translate(30.809 10.162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_705",
    "data-name": "Group 705"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2063",
    "data-name": "Path 2063",
    d: "M249.551,201.243l.064,62.646c-.286-.033-.563-.066-.84-.091l-.064-62.555Z",
    transform: "translate(-248.711 -201.243)",
    fill: "#aec6d6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2064",
    "data-name": "Path 2064",
    d: "M253.269,226.571a.892.892,0,1,1-.893-.891A.892.892,0,0,1,253.269,226.571Z",
    transform: "translate(-249.237 -205.878)",
    fill: "#aec6d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M253.282,239.485a.892.892,0,1,1-.893-.892A.892.892,0,0,1,253.282,239.485Z",
    transform: "translate(-249.24 -208.327)",
    fill: "#aec6d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    d: "M253.3,252.031a.892.892,0,1,1-.893-.891A.892.892,0,0,1,253.3,252.031Z",
    transform: "translate(-249.242 -210.706)",
    fill: "#aec6d6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2067",
    "data-name": "Path 2067",
    d: "M253.308,264.577a.893.893,0,1,1-.894-.891A.892.892,0,0,1,253.308,264.577Z",
    transform: "translate(-249.244 -213.086)",
    fill: "#aec6d6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2068",
    "data-name": "Path 2068",
    d: "M269.754,232.527c-1.819-6.231-12.761-12.735-15.713-17.661-2.131-3.557-2.876-9.463-3.125-12.471l3.243-3.25-4.514-1.791-4.511,1.8,3.33,3.322c-.271,16.279,8.035,18.985,11.314,25.416,3.406,6.682,3.3,15.748,3.3,15.748l5.216,4.074,3.168-5.215A35.784,35.784,0,0,0,269.754,232.527Z",
    transform: "translate(-217.224 -190.344)",
    fill: "#0d939c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    d: "M259.544,188.7a14.685,14.685,0,0,1-8.838,6.993,10.506,10.506,0,0,0,7.411,3.16c4.757.08,3.251-10.155,3.251-10.155Z",
    transform: "translate(-218.281 -188.703)",
    fill: "#c7d7e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2070",
    "data-name": "Path 2070",
    d: "M239.3,188.727a14.684,14.684,0,0,0,8.853,6.975,10.512,10.512,0,0,1-7.406,3.176c-4.757.09-3.271-10.149-3.271-10.149Z",
    transform: "translate(-215.73 -188.708)",
    fill: "#c7d7e2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan2);
export default __webpack_public_path__ + "static/media/plan2.d37fcd2464874228dd5b141f692e5dac.svg";
export { ForwardRef as ReactComponent };